import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/updateRiskProperty', params).then((response) => {
        return response.data;
    });
};
export const useMutationUpdateRiskProperty = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id: number;
    status?: 'NEW' | 'OPEN' | 'CLOSED';
    assignee?: string;
}
